module.exports = __webpack_public_path__ + "img/1.fa627e87.png";